import styled, { css } from "styled-components";
import { NotificationTypeEnum } from "./Notification";
import { theme } from "../../../constants/StyledComponents";

export const StyledNotificationOverlay = styled.div`
  z-index: 9998;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledNotification = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  background: ${theme.colors.white};
  gap: 20px;
  width: 270px;
  height: 270px;
  border-radius: ${theme.variables.border_radius_1};
  box-shadow: ${theme.variables.modal_box_shadow};
  border: 1px solid ${theme.colors.purple_2};
  padding: 70px 30px 30px;
  box-sizing: border-box;
  text-align: center;

  & > .text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 30px;
    width: 100%;
    margin-bottom: 10px;
  }
`;

const circleStyles = (type = NotificationTypeEnum.SUCCESS) =>
  ({
    success: css`
      background-color: ${theme.colors.green};
    `,
    warning: css`
      background-color: ${theme.colors.yellow_1};
    `,
    error: css`
      background-color: ${theme.colors.red_1};
    `,
  })[type];

export const StyledNotificationCircle = styled.div<{
  $type: NotificationTypeEnum;
}>`
  position: absolute;
  top: -30px;
  left: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  ${({ $type }) => circleStyles($type)}
  border-radius: 100px;
  box-shadow: ${theme.variables.modal_box_shadow};
  border: 1px solid ${theme.colors.purple_2};
`;
